import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY } from "../../data/content";

const columns = [
  {
    heading: "Solutions",
    links: [
      { label: "AI & Machine Learning", to: "/solutions/ai-ml" },
      { label: "Data Engineering", to: "/solutions/data-engineering" },
      { label: "Analytics & BI", to: "/solutions/analytics-bi" },
      { label: "Predictive Analytics", to: "/solutions" },
      { label: "Cloud Data", to: "/solutions/cloud-data" },
      { label: "Automation", to: "/solutions" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Industries", to: "/industries" },
      { label: "Insights", to: "/insights" },
      { label: "Careers", to: "/about" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Blog", to: "/insights" },
      { label: "Case Studies", to: "/#case-studies" },
      { label: "FAQs", to: "/contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#0B1220] text-white" data-testid="footer">
      <div className="ad-container py-16 lg:py-20">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4 lg:grid-cols-6">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-0.5">
              <span className="text-lg font-extrabold tracking-tight text-white">ALL DATA TECH</span>
              <span className="text-lg font-extrabold text-[#00C7D9]">.</span>
            </Link>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              We turn complex data into intelligent decisions, automation and measurable business outcomes.
            </p>
            <p className="mt-6 text-lg font-bold text-gradient">{COMPANY.tagline}</p>
          </div>

          {columns.map((col) => (
            <div key={col.heading}>
              <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">{col.heading}</h3>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-slate-300 transition-colors hover:text-white">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="col-span-2 lg:col-span-1">
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Contact</h3>
            <ul className="mt-5 space-y-4 text-sm text-slate-300">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#00C7D9]" />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 flex-shrink-0 text-[#00C7D9]" />
                <a href={`mailto:${COMPANY.email}`} className="break-all transition-colors hover:text-white">{COMPANY.email}</a>
              </li>
            </ul>
            <Link to="/consultation" className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-[#00C7D9] hover:text-white">
              Book a Consultation <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-slate-500 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</p>
          <p className="font-semibold uppercase tracking-[0.18em]">Data → Engineering → Intelligence → Impact</p>
        </div>
      </div>
    </footer>
  );
}
